import React, { useState } from 'react';
import ModalBody, { ModalProps } from '../modals/ModalBody';
import { Box, Button } from '@mui/material';
import DropDown, { OptionType } from '../DropDown';
import { useTranslation } from 'react-i18next';
import { CreateFormAccessBody } from '../../services/apiSLTP/qhse/forms/formAccess';
import { User } from '../../services/apiSLTP/users';
import { useUsersQuery } from '../../hooks/queries/useUsersQuery';

interface AddFormAccessModalProps extends ModalProps {
    onCreateFormAccess: (data: CreateFormAccessBody) => void;
    groupId: string;
}

const AddFormAccessModal: React.FC<AddFormAccessModalProps> = ({ open, handleClose, onCreateFormAccess, groupId }) => {
    const { t } = useTranslation();
    const [selectedUser, setSelectedUser] = useState<OptionType | null>(null);

    const { data: dataUsers, isLoading: isUsersLoading } = useUsersQuery({ queries: { active: true } });

    const handleOk = () => {
        if (!selectedUser) return;
        onCreateFormAccess({
            userId: selectedUser.value,
            groupId,
        });
        setSelectedUser(null);
        handleClose();
    };

    const options: OptionType[] =
        dataUsers
            ?.filter((user) => !user.isSpecial)
            .map((u) => ({
                label: `${u.firstName} ${u.lastName}`,
                value: u._id,
            })) || [];

    return (
        <ModalBody
            title={t('userAccess')}
            subTitle={t('add')}
            closeText={t('cancel')}
            okText={t('validate')}
            open={open}
            handleClose={handleClose}
            handleOk={handleOk}
        >
            <Box>
                <DropDown
                    items={options}
                    selectedItem={selectedUser}
                    handleChange={(_, value) => setSelectedUser(value)}
                    inputLabel={t('user')}
                    loading={isUsersLoading}
                />
            </Box>
        </ModalBody>
    );
};

export default AddFormAccessModal;
